import React, { ReactElement, useEffect, useState } from 'react';
import { Button, Col, Row, Tooltip, Select, Form, Statistic } from 'antd';
import { CloseOutlined as Close } from '@ant-design/icons';
import { GUTTOR_SPACE, VALIDATE_MESSAGES } from '../../../../../../../shared/constants/commonConstants';
import { FormOTPInput } from '../../../../../../../shared/components/crmFormElement/FormInput';
import { useDispatch, useSelector } from 'react-redux';
import { abhaVerificationSentOtp, conformOtpForAbhaId } from '../../../../../../../store/actions/newAdmissionAction';
import { RootState } from '../../../../../../../store';

export const VerifyAbhaIdModel = ({
  data, healthid, setIsAbhaIdLoading,
  closeModel,
}: any): ReactElement => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const [abhaIDAuthForm] = Form.useForm();
  const [ selectedAbhaAuthMethod, setSelectedAbhaAuthMethod ] = useState('');
  const [ AbhaAllMethods, setAbhaAllMethods ] = useState([]);
  const [ shouldAskForOTP, setShouldAskForOTP ] = useState(false);
  const [ sendingOtp, setSendingOtp ] = useState(false);
  const [isShowOtpModal, setIsShowOtpModal] = useState(false);
  const [resend, setResend] = useState(0);
  const [resendText, setResendText] = useState('Resend OTP in');
  const Countdown = Statistic.Countdown;
  const deadline = Date.now() + 601000;
  const [otpForm] = Form.useForm();

  const { newAdmission: {
    txnId, abhaIdOtpVerificationError, isLoadingAuthenticate,
  } } = useSelector((state: RootState): RootState => state);

  useEffect((): void => {
    const updatedData = data.filter((d: string): any => d !== 'DEMOGRAPHICS');
    setAbhaAllMethods(updatedData);
    setIsAbhaIdLoading(false);
  }, [data]);

  useEffect((): void => {
    if (txnId) {
      isShowOtpModal ? setShouldAskForOTP(true) : setShouldAskForOTP(false); // for abha otp modal
    }
  }, [txnId]);

  useEffect((): void => {
    setSendingOtp(false);
    if (abhaIdOtpVerificationError) {
      setIsAbhaIdLoading(false);
    }
  }, [abhaIdOtpVerificationError]);

  const abhaModeSelectFormSubmitHandler = (value: any): void => {
    const abhaInitPayload = {
      authMethod: selectedAbhaAuthMethod,
      healthid,
    };

    dispatch(abhaVerificationSentOtp(abhaInitPayload));
    setIsShowOtpModal(true);
  };

  const otpSubmitHandler = (): void => {
    const otp = otpForm.getFieldValue('otp');
    if (otp.length === 6) {
      const payload = {
        otp, txnId, selectedAbhaAuthMethod,
      };
      setSendingOtp(true);
      dispatch(conformOtpForAbhaId(payload));
    }
  };

  const onCloseBtnClickHandler = (): void => {
    setShouldAskForOTP(false);
    setIsAbhaIdLoading(false);
    closeModel();
  };

  const onFinish = (): any => {
    setResendText(`Didn't receive OTP?`);
    setResend((prevState: any): any => prevState + 1);
  };

  const resendComponent = resend > 0 ? <p className="resend-link" onClick={abhaModeSelectFormSubmitHandler}>
    Resend </p> : <Countdown value={deadline} format="mm:ss" onFinish={onFinish} />;

  return (
    <React.Fragment>
      <div className={'back-drop'} />
      <div
        data-testid="Id-card-modal"
        className={`abha-id-auth-modal minimize-modal-wrapper open `}
      >
        <div className={`modal-header`}>
          <Tooltip title="Close document window">
            <span
              onClick={onCloseBtnClickHandler} className="close-btn ant-modal-close-x" data-testid="minimize-icon">
              <Close />
            </span>
          </Tooltip>
        </div>
        <div className="modal-body scrollbar">
          {shouldAskForOTP
            ? (
              <>
                <Row gutter={GUTTOR_SPACE} className="text-center">
                  <Col md={20} offset={2}>
                    <label>Enter OTP received on your mobile number </label>
                  </Col>
                </Row>
                <Form
                  layout="vertical"
                  form={otpForm}
                  validateMessages={VALIDATE_MESSAGES}
                  onFinish={otpSubmitHandler}
                >
                  <Row gutter={GUTTOR_SPACE}>
                    <Col md={18} offset={6}>
                      <FormOTPInput
                        form={otpForm}
                        autoFocus={true}
                        length={6}
                        className="otpContainer"
                        inputClassName="otpInput"
                      />
                    </Col>
                  </Row>
                  <Row gutter={GUTTOR_SPACE} className="otp-component-text">
                    <Col md={9} offset={4}>
                      {`${resendText}`}
                    </Col>
                    <Col>{resendComponent}
                    </Col>
                  </Row>
                  <Row>
                    <Col md={24} className="text-center">
                      <Button
                        type="primary"
                        loading={sendingOtp}
                        htmlType="submit">
                        Submit OTP
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </>
            ) : (
              <Form
                layout="vertical"
                form={abhaIDAuthForm}
                validateMessages={VALIDATE_MESSAGES}
                onFinish={abhaModeSelectFormSubmitHandler}
              >
                <Row gutter={GUTTOR_SPACE}>
                  <Col md={10}>
                    Do you want to verify ABHA ID ?
                  </Col>
                  <Col md={8}>
                  <Form.Item
                    name="setSelectedAbhaAuthMethod"
                    rules={[{
                      required: true, message: 'Auth mode is required!',
                    }]}
                    >
                      <Select
                        style={{ width: '100%' }}
                        value={selectedAbhaAuthMethod}
                        allowClear={true}
                        onClear={(): void => setSelectedAbhaAuthMethod('')}
                        onSelect={setSelectedAbhaAuthMethod}
                      >
                        {AbhaAllMethods &&
                          AbhaAllMethods.map( (ele: string): ReactElement =>
                            <Option key={ele} value={ele}>{ele}</Option>,
                          )
                        }
                      </Select>
                  </Form.Item>
                  </Col>
                  <Col md={6} className="text-center">
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={isLoadingAuthenticate}
                    >
                      Authenticate
                    </Button>
                  </Col>
                </Row>
              </Form>
          )}
        </div>
      </div>
    </React.Fragment >
  );
};
